// const isDev = process.env.NODE_ENV === 'development'
const isDev = false
const productKeys = {
  SWIPE: 'swipeFile',
  DISCOVERY: 'discovery',
  BRIEFS: 'briefs',
  SPYDER: 'spyder',
  LENS: 'lens',
  API: 'api'
}
const PRODUCT_ASSETS = [
  {
    imgUrl: require('../../assets/icons/swipe-file.png'),
    label: 'Swipe File',
    key: productKeys.SWIPE
  },
  {
    imgUrl: require('../../assets/icons/discovery.png'),
    label: 'Discovery',
    key: productKeys.DISCOVERY
  },
  {
    imgUrl: require('../../assets/icons/briefs.png'),
    label: 'Briefs',
    key: productKeys.BRIEFS
  },
  {
    imgUrl: require('../../assets/icons/spyder.png'),
    label: 'Spyder',
    key: productKeys.SPYDER
  },
  {
    imgUrl: require('../../assets/icons/lensIcon.png'),
    label: 'Lens',
    key: productKeys.LENS
  },
  {
    imgUrl: require('../../assets/images/foreplay-api-logo.png'),
    label: 'API Access',
    key: productKeys.API
  }
]
const baseProducts = [productKeys.SWIPE, productKeys.DISCOVERY, productKeys.BRIEFS, productKeys.API]

const LEGACY_SUBSCRIPTION_PLANS = [
  {
    key: 'legacy_inspiration_plan',
    tier: 'Legacy Inspiration',
    description: 'For teams of all sizes saving & organizing ad inspiration.',
    baseUserCount: 1
  },
  {
    key: 'legacy_full_workflow_plan',
    tier: 'Legacy Full Workflow',
    description: 'For teams of all sizes saving & organizing ad inspiration.',
    baseUserCount: 2
  }
]

const SUBSCRIPTION_PLANS = [
  {
    key: 'basic_plan',
    tier: 'Basic',
    description: 'For teams of all sizes saving & organizing ad inspiration.',
    price: {
      monthly: 59,
      annual: 49
    },
    annualSavings: 120,
    priceId: {
      monthly: isDev ? 'price_1RLrttAQtq0TW7KZZXUFVcuR' : 'price_1RPEMoAQtq0TW7KZDYBYE0oG',
      annual: isDev ? 'price_1RLruxAQtq0TW7KZAH4QP9ZM' : 'price_1RMEMsAQtq0TW7KZSDalZ3dH'
    },
    includedProducts: baseProducts,
    baseUserCount: 1
  },
  {
    key: 'workflow_plan',
    tier: 'Workflow',
    description: 'The complete winning ad workflow for scaling teams.',
    isPopular: true,
    price: {
      monthly: 175,
      annual: 149
    },
    annualSavings: 310,
    priceId: {
      monthly: isDev ? 'price_1RLrqCAQtq0TW7KZIU5T0Xc4' : 'price_1RMELcAQtq0TW7KZEgwOHpVQ',
      annual: isDev ? 'price_1RLrsXAQtq0TW7KZse4iZeOD' : 'price_1RMELgAQtq0TW7KZw98seOJy'
    },
    addOns: {
      lens: {
        monthly: { priceId: isDev ? 'price_1RMCDWAQtq0TW7KZm0S41GTK' : 'price_1RMEM4AQtq0TW7KZ0homnuxU', quantity: 1 },
        annual: { priceId: isDev ? 'price_1RMCDyAQtq0TW7KZC9xAvvhd' : 'price_1RiyauAQtq0TW7KZM2Fa9vZl', quantity: 1 }
      },
      spyder: {
        monthly: { priceId: isDev ? 'price_1RLrdWAQtq0TW7KZHOm4TYN8' : 'price_1RMEDUAQtq0TW7KZudgiOTA4', quantity: 10 },
        annual: { priceId: isDev ? 'price_1RLrY7AQtq0TW7KZsBO2rDw4' : 'price_1RMEDSAQtq0TW7KZPC6SVzF4', quantity: 999 }
      }
    },
    includedProducts: [...baseProducts, productKeys.SPYDER, productKeys.LENS],
    baseUserCount: 5,
    baseSpyder: {
      monthly: 15,
      annual: 999
    },
    baseLens: 1
  },
  {
    key: 'agency_plan',
    tier: 'Agency',
    description: 'Supercharging marketing groups to scale multiple ad accounts.',
    price: {
      monthly: 459,
      annual: 389
    },
    annualSavings: 820,
    priceId: {
      monthly: isDev ? 'price_1RM9wfAQtq0TW7KZYvcvcvwu' : 'price_1RPEL0AQtq0TW7KZRHIntE4x',
      annual: isDev ? 'price_1RLsqMAQtq0TW7KZFlUHbFAf' : 'price_1RMDweAQtq0TW7KZuOKRIR6Z'
    },
    addOns: {
      lens: {
        monthly: { priceId: isDev ? 'price_1RMByYAQtq0TW7KZwkAtFuCn' : 'price_1RPAVaAQtq0TW7KZxMznyOl2', quantity: 10 },
        annual: { priceId: isDev ? 'price_1RLnrcAQtq0TW7KZykH6gJmL' : 'price_1SVewrAQtq0TW7KZLtqVykZ5', quantity: 10 }
      },
      spyder: {
        monthly: { priceId: isDev ? 'price_1RLrdWAQtq0TW7KZHOm4TYN8' : 'price_1RMEDUAQtq0TW7KZudgiOTA4', quantity: 25 },
        annual: { priceId: isDev ? 'price_1RLrY7AQtq0TW7KZsBO2rDw4' : 'price_1RMEDSAQtq0TW7KZPC6SVzF4', quantity: 999 }
      }
    },
    includedProducts: [...baseProducts, productKeys.SPYDER, productKeys.LENS],
    baseUserCount: 10,
    baseSpyder: {
      monthly: 50,
      annual: 999
    },
    baseLens: 10
  }
]

const SPYDER_PACKAGES = [
  {
    key: 'spyder_10',
    brandCount: 10,
    monthlyPrice: 99,
    savingsPercent: 0,
    priceId: {
      monthly: 'price_1NpudLAQtq0TW7KZbBqLvDiO'
    }
  },
  {
    key: 'spyder_20',
    brandCount: 20,
    monthlyPrice: 149,
    savingsPercent: 25,
    priceId: {
      monthly: 'price_1Npue6AQtq0TW7KZblNmFnGu'
    }
  },
  {
    key: 'spyder_30',
    brandCount: 30,
    monthlyPrice: 199,
    savingsPercent: 30,
    priceId: {
      monthly: 'price_1NpufDAQtq0TW7KZ6c4ndclX'
    }
  },
  {
    key: 'spyder_50',
    brandCount: 50,
    monthlyPrice: 249,
    savingsPercent: 50,
    priceId: {
      monthly: 'price_1NpuheAQtq0TW7KZpK9e6t06'
    }
  }
]

const GUARANTEE_DETAILS = [
  {
    icon: require('../../components/globals/Icons/MoneyBackIcon.vue'),
    title: 'Money-back guarantee',
    desc: 'Full refunds within 15 days of purchase'
  },
  {
    icon: require('../../components/globals/Icons/ShieldCancelIcon.vue'),
    title: 'Cancel Anytime',
    desc: 'No strings attached cancellations'
  },
  {
    icon: require('../../components/globals/Icons/ChatSupportIcon.vue'),
    title: '21/5 Livechat support',
    desc: 'Access support Mon-Fri 6 AM - 5 PM EST.'
  }
]

const ENTERPRISE_BENEFITS = [
  'Unlimited users & product usage',
  'Priority in-app or Slack support',
  'Early access to new features & integrations'
]

const TRUSTED_COMPANIES = [
  'https://publicassets.foreplay.co/trusted-companies/hello-fresh.png',
  'https://publicassets.foreplay.co/trusted-companies/click-funnels.png',
  'https://publicassets.foreplay.co/trusted-companies/true-classic.png',
  'https://publicassets.foreplay.co/trusted-companies/vayner-media.png',
  'https://publicassets.foreplay.co/trusted-companies/canva.png'
]

const SUBSCRIPTION_STATES = {
  INCOMPLETE: 'incomplete',
  INCOMPLETE_EXPIRED: 'incomplete_expired',
  TRIALING: 'trialing',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  UNPAID: 'unpaid',
  PAUSED: 'paused',
  NOT_ACTIVE: 'not_active'
}
export {
  ENTERPRISE_BENEFITS,
  GUARANTEE_DETAILS,
  TRUSTED_COMPANIES,
  SUBSCRIPTION_PLANS,
  PRODUCT_ASSETS,
  SUBSCRIPTION_STATES,
  LEGACY_SUBSCRIPTION_PLANS,
  SPYDER_PACKAGES
}
